export enum Namespace {
  SVG = 'http://www.w3.org/2000/svg',
}